module.exports = __webpack_public_path__ + "img/img_top10_production.6ae263e2.png";